import * as React from 'react';
import styled from 'styled-components';
import H1 from '@sdk/components/ui/typography/H1';
import H4 from '@sdk/components/ui/typography/H4';
import gettext from '@sdk/lang/gettext';

import ExperimentSvg from '../../assets/svg/images/experiment.svg';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #eaeef2;
  margin-top: 20px;
`;

type Props = {
  displayWeekMode: () => void;
};

const ScheduleEmptyScreen: React.FC<React.PropsWithChildren<Props>> = ({ displayWeekMode }) => {
  return (
    <Container>
      <ExperimentSvg style={{ width: 600, height: 400 }} />
      <H1 top={20} bottom={10}>
        {gettext('We&apos;re working hard to bring more modes into experimental tab')}
      </H1>
      <H4 top={20} bottom={10}>
        <>
          {gettext('For now please use')} <a onClick={displayWeekMode}>{gettext('week mode')}</a>
        </>
      </H4>
    </Container>
  );
};

export default ScheduleEmptyScreen;
